/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVyberovaSkupina extends GContentBase<SeznamAdmVyberovaSkupinaObj> {
        private seznamObj: SeznamAdmVyberovaSkupinaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVyberovaSkupinaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVyberovaSkupina",
                contentCaption: "jres:33000430", //RC 33000430 : V�b�rov� skupiny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_blk}"
                },
                gridSettings: {
                    columnOrder: "nazev,poznamka,typ_txt,dat_zmena,zmenu_provedl,dat_od,dat_do,ixs_blk",
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVyberovaSkupinaObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVyberovaSkupina", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVyberovaSkupina",
                newRecord: isNew,
                ixs_blk: isNew == true ? null : data.ixs_blk
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmVyberovaSkupina: {
                    caption: "jres:33000437", //RC 33000437 : Obsah v�b�rov� skupiny
                    icon: "fa-link",
                    run: () => {
                        this.openSeznamAdmVyberovaSkupina();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*", "actNewDetail*", "actAddToComparison*",
                {
                    type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                        {
                            action: this.cnt.actions.actOpenSeznamAdmVyberovaSkupina
                        }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenSeznamAdmVyberovaSkupina*"])
        }

        createFilterForm() {
           
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {
            
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVyberovaSkupina.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamAdmVyberovaSkupina?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_blk),
                nazev: data.nazev
            }
        }

        private openSeznamAdmVyberovaSkupina() {
            var data = this.grid.ggrid("activeRow");
            if (data != null && data != undefined) 
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVyberovaSkupinaObsah"], { Id: "SeznamAdmVyberovaSkupinaObsah",  ixs_blk: data.ixs_blk })
        }
    }
}